var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InnerImageZoom',{attrs:{"src":_vm.file.Metadata.PreviewFile + _vm.SasToken,"zoomSrc":_vm.file.Uri + _vm.SasToken}})
}
var staticRenderFns = []

export { render, staticRenderFns }